export default __webpack_public_path__ + "static/media/main_banner.d80f6326.png";